import { Button } from "@/components/ui/button";
import { BarChart3, TrendingUp, GraduationCap } from "lucide-react";
const HeroSection = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative min-h-[60vh] sm:h-[70vh] bg-background flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-24 sm:pt-16 pb-8 z-10">
      {/* Enhanced Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-secondary/10 to-primary/5"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-secondary/20 via-transparent to-transparent"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-primary/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/3 right-1/4 w-40 h-40 bg-accent/10 rounded-full blur-3xl"></div>
      
      <div className="relative max-w-5xl mx-auto text-center">
        {/* Main Heading */}
        <h1 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold mb-6 sm:mb-8 max-w-4xl mx-auto leading-tight text-center">
          <span className="text-foreground">Investir é cuidar de você, da sua família e do seu </span>
          <span className="bg-gradient-primary bg-clip-text text-transparent">patrimônio</span>
        </h1>
        
        {/* Feature Highlights - inline on mobile */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-8 mb-8 sm:mb-12">
          <div className="flex items-center gap-2 text-muted-foreground">
            <div className="flex items-center justify-center w-8 h-8 sm:w-12 sm:h-12 bg-primary/10 rounded-full">
              <BarChart3 className="w-4 h-4 sm:w-6 sm:h-6 text-primary" />
            </div>
            <span className="text-xs sm:text-sm font-medium">Índice e Dólar</span>
          </div>
          
          <div className="flex items-center gap-2 text-muted-foreground">
            <div className="flex items-center justify-center w-8 h-8 sm:w-12 sm:h-12 bg-primary/10 rounded-full">
              <TrendingUp className="w-4 h-4 sm:w-6 sm:h-6 text-primary" />
            </div>
            <span className="text-xs sm:text-sm font-medium">Alta Rentabilidade</span>
          </div>
          
          <div className="flex items-center gap-2 text-muted-foreground">
            <div className="flex items-center justify-center w-8 h-8 sm:w-12 sm:h-12 bg-primary/10 rounded-full">
              <GraduationCap className="w-4 h-4 sm:w-6 sm:h-6 text-primary" />
            </div>
            <span className="text-xs sm:text-sm font-medium">Gestão Especializada</span>
          </div>
        </div>
        
        {/* CTA Button */}
        <div className="flex justify-center relative z-50">
          <button onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          const element = document.getElementById('contato');
          if (element) {
            const headerOffset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - headerOffset;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }} className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-lg font-medium bg-gradient-primary text-primary-foreground hover:shadow-glow transition-all duration-300 shadow-elegant h-11 px-10 py-6 cursor-pointer touch-manipulation active:scale-95" style={{
          WebkitTapHighlightColor: 'rgba(0,0,0,0)',
          userSelect: 'none'
        }}>
            Entre em Contato
          </button>
        </div>
      </div>
      
      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-secondary/30 to-transparent"></div>
    </section>;
};
export default HeroSection;